import TitleHeader from "@/components/TitleHeader";
import { useUserInfo } from "@/context/UserInfo";
import { Box, Flex, Text, Image, useDisclosure } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import I1Icon from "./assets/i1.png";
import B1Icon from "./assets/b1.png";
import dayjs from "dayjs";
import { GoIcon } from "@/components/icons";
import IncompleteDrawer from "./IncompleteDrawer";
import { ReactComponent as WarnIcon } from "./assets/warn.svg";
import { useEffect } from "react";
import EditIcon from "./assets/edit.png";
import CautionDrawer from "./CautionDrawer";
import SuccessIcon from "./assets/success.png";

const LinkStatus = ({ status, label }: { status: string; label: string }) => {
  return (
    <Flex align={"center"}>
      {status === "not_started" && (
        <Box
          sx={{
            width: "10px",
            height: "10px",
            backgroundColor: "#DEDEDE",
            borderRadius: "50%",
          }}
        ></Box>
      )}

      {status === "rejected" && (
        <Flex
          sx={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            border: "1px solid #F13434",
          }}
          align={"center"}
          justify={"center"}
        >
          <Box
            sx={{
              width: "10px",
              height: "10px",
              backgroundColor: "#F13434",
              borderRadius: "50%",
            }}
          ></Box>
        </Flex>
      )}
      {status === "incomplete" && (
        <Flex
          sx={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            border: "1px solid #D8762B",
          }}
          align={"center"}
          justify={"center"}
        >
          <Box
            sx={{
              width: "10px",
              height: "10px",
              backgroundColor: "#D8762B",
              borderRadius: "50%",
            }}
          ></Box>
        </Flex>
      )}

      {status === "approved" && (
        <Image
          src={SuccessIcon}
          sx={{
            width: "10px",
            height: "10px",
          }}
        ></Image>
      )}

      <Text
        sx={{
          color: "#333",
          textAlign: "center",
          fontFamily: "DIN",
          fontSize: "14px",
          fontWeight: 700,
          marginLeft: "5px",
        }}
      >
        {label}
      </Text>
    </Flex>
  );
};

const GoButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  return (
    <Flex
      sx={{
        width: "30px",
        height: "30px",
        backgroundColor: disabled ? "#DEDEDE" : "#D8762B",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "auto",
      }}
    >
      <GoIcon
        style={{
          color: disabled ? "#BBBBBB" : "#fff",
        }}
        onClick={() => {
          if (!disabled) {
            onClick();
          }
        }}
      />
    </Flex>
  );
};

const VerifyInfo = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: cautionOpen,
    onOpen: cautionOnOpen,
    onClose: cautionOnClose,
  } = useDisclosure();

  const { bridgeCustomer, handleGetCustomer } = useUserInfo();
  const isIndividual = bridgeCustomer?.type === "individual";

  const tosCompleted = bridgeCustomer?.has_accepted_terms_of_service;

  const Status = () => {
    if (
      bridgeCustomer?.kyc_status === "not_started" ||
      !bridgeCustomer?.kyc_status
    ) {
      return (
        <Text
          sx={{
            color: "#848484",
            fontFamily: "DIN",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
          }}
        >
          Not Started
        </Text>
      );
    } else if (bridgeCustomer?.kyc_status === "incomplete") {
      return (
        <Flex alignItems="center" onClick={onOpen}>
          <Text
            sx={{
              color: "#D8762B",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 500,
            }}
          >
            Incomplete
          </Text>
          {bridgeCustomer.rejection_reasons.length > 0 && (
            <WarnIcon
              style={{
                color: "#D8762B",
                width: "14px",
                height: "14px",
                marginLeft: "4px",
              }}
            ></WarnIcon>
          )}
        </Flex>
      );
    } else if (bridgeCustomer.kyc_status === "rejected") {
      return (
        <Flex alignItems="center" onClick={onOpen}>
          <Text
            sx={{
              color: "#F13434",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 500,
            }}
          >
            Rejected
          </Text>{" "}
          {bridgeCustomer.rejection_reasons.length > 0 && (
            <WarnIcon
              style={{
                color: "#F13434",
                width: "14px",
                height: "14px",
                marginLeft: "4px",
                cursor: "pointer",
              }}
            ></WarnIcon>
          )}
        </Flex>
      );
    } else if (bridgeCustomer?.kyc_status === "approved") {
      return (
        <Text
          sx={{
            color: "#00A54D",
            fontFamily: "DIN",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
          }}
        >
          Completed
        </Text>
      );
    }

    return <></>;
  };

  const UpdateButton = () => {
    return (
      <Image
        src={EditIcon}
        sx={{
          width: "30px",
          height: "30px",
          cursor: "pointer",
        }}
        onClick={() => {
          cautionOnOpen();
        }}
      ></Image>
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleGetCustomer();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Flex
      sx={{
        padding: "20px",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <TitleHeader
        title="Verification"
        color="#D8762B"
        onBack={() => navigate("/")}
        rightComponent={<UpdateButton />}
      />
      <Box>
        <Text
          sx={{
            color: "#333",
            fontFamily: "DIN",
            fontSize: "20px",
            fontWeight: 700,
            marginTop: "24px",
          }}
        >
          Type
        </Text>
        <Flex
          sx={{
            marginTop: "15px",
          }}
          alignItems="center"
        >
          <Image
            src={isIndividual ? I1Icon : B1Icon}
            sx={{
              width: "30px",
              height: "30px",
              marginRight: "10px",
            }}
          ></Image>
          <Text sx={{ fontSize: "16px", fontWeight: 500 }}>
            {isIndividual ? "Individual" : "Business"}
          </Text>
        </Flex>
        <Text
          sx={{
            color: "#333",
            fontSize: "20px",
            fontWeight: 700,
            marginTop: "15px",
          }}
        >
          Name
        </Text>
        <Text
          sx={{
            color: "#333",
            fontSize: "16px",
            fontWeight: 500,
            marginTop: "15px",
          }}
        >
          {isIndividual
            ? `${bridgeCustomer?.first_name} ${bridgeCustomer?.last_name}`
            : `${bridgeCustomer?.full_name} `}
        </Text>{" "}
        <Text
          sx={{
            color: "#333",
            fontSize: "20px",
            fontWeight: 700,
            marginTop: "15px",
          }}
        >
          Email
        </Text>
        <Text
          sx={{
            color: "#333",
            fontSize: "16px",
            fontWeight: 500,
            marginTop: "15px",
          }}
        >
          {bridgeCustomer?.email}
        </Text>
        <Text
          sx={{
            color: "#333",
            fontSize: "20px",
            fontWeight: 700,
            marginTop: "15px",
          }}
        >
          Date
        </Text>
        <Text
          sx={{
            marginTop: "15px",
          }}
        >
          {dayjs(bridgeCustomer?.created_at).format("MMM D, YYYY")}
        </Text>
      </Box>
      <Box
        sx={{
          marginTop: "20px",
          paddingTop: "20px",
          borderTop: "1px dashed #D8762B",
        }}
      >
        <Text
          sx={{
            color: "#333",
            fontFamily: "DIN",
            fontSize: "20px",
            fontWeight: 700,
          }}
        >
          Terms of Service
        </Text>
        <Flex
          sx={{
            justifyContent: "space-between",
            marginTop: "12px",
          }}
          alignItems="center"
        >
          <Text
            sx={{
              color: tosCompleted ? "#00A54D" : "#848484",
            }}
          >
            {tosCompleted ? "Completed" : "Not Started"}
          </Text>
          <GoButton
            onClick={() => {
              window.open(bridgeCustomer?.tos_link, "_blank");
            }}
            disabled={tosCompleted}
          />
        </Flex>
        <Text
          sx={{
            color: "#333",
            fontFamily: "DIN",
            fontSize: "20px",
            fontWeight: 700,
            marginTop: "12px",
          }}
        >
          KYC
        </Text>
        <Flex
          sx={{
            marginTop: "12px",
          }}
          alignItems="center"
        >
          <Status></Status>

          <GoButton
            onClick={() => {
              window.open(bridgeCustomer?.kyc_link, "_blank");
            }}
            disabled={bridgeCustomer?.kyc_status === "approved"}
          />
        </Flex>{" "}
        <Flex sx={{ marginTop: "20px" }} justifyContent="center" gap={"20px"}>
          <LinkStatus
            status={tosCompleted ? "approved" : "not_started"}
            label="TOS"
          ></LinkStatus>
          <LinkStatus
            status={bridgeCustomer?.kyc_status}
            label="KYC"
          ></LinkStatus>
        </Flex>
      </Box>
      <IncompleteDrawer
        rejectionReasons={bridgeCustomer?.rejection_reasons || []}
        isOpen={isOpen}
        onClose={onClose}
        isRejected={bridgeCustomer?.status === "rejected"}
      />
      <CautionDrawer isOpen={cautionOpen} onClose={cautionOnClose} />
    </Flex>
  );
};

export default VerifyInfo;
